import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ButtonLoading } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { CreateLoanApi, LoanApi, OrganizationApi } from "../../../../../services/Api/types";
import { api } from "../../../../../services/Security/api";
import NewLoanPreviewBasicInfoCard from "./NewLoanPreviewBasicInfoCard";
import NewLoanPreviewItemsCard from "./NewLoanPreviewItemsCard";
import NewLoanPreviewTypeCard from "./NewLoanPreviewTypeCard";

interface Props {
	loan: LoanApi;
	organization?: OrganizationApi;
	externalPartners?: any[];
	adminOrOffice?: boolean;
	loanExist?: boolean;
}

const NewLoanPreview = ({ loan, organization, adminOrOffice, externalPartners }: Props) => {
	const form = useForm<CreateLoanApi>({
		defaultValues: {
			license_level: undefined,
			partner_id: Number(loan.partner?.id),
		},
	});
	const { getValues, setError } = form;
	const [loading, setLoading] = useState(false);
	const { t } = useTranslation("admin");
	const { addSuccessFlash, addFlash } = useFlash();
	const history = useHistory();
	const createLoan = async () => {
		setLoading(true);
		try {
			const newLoan = {
				partner_id: loan.partner ? loan.partner?.id : getValues().partner_id,
				organization_id: Number(organization?.id),
				items: loan.items,
				reference_id: loan.reference_id,
				type: loan.type,
				license_level: getValues().license_level,
			};
			const resp = await api.user().createLoan(newLoan);
			addSuccessFlash(t("common.flash.saved", { ns: "lib" }));
			history.push(`/partnership/${resp.partner?.id}/loans/${resp.id}`);
		} catch (e) {
			handleError.form(e, setError, addFlash);
		}
		setLoading(false);
	};

	return (
		<>
			<div className={"content-preview"}>
				<NewLoanPreviewBasicInfoCard
					loan={loan}
					form={form}
					externalPartners={externalPartners}
					organization={organization}
					adminOrOffice={adminOrOffice}
				/>
				<NewLoanPreviewItemsCard loan={loan} />
				<NewLoanPreviewTypeCard form={form} />
				<ButtonLoading loading={loading} onClick={createLoan}>
					{t("common.action.create_loan")}
				</ButtonLoading>
			</div>
		</>
	);
};
export default NewLoanPreview;
